import Blog from "./components/Blog";
import GetInTouch from "../home/components/GetInTouch";

const index = () => {
  return (
    <>
      <Blog />
      <GetInTouch />
    </>
  );
};

export default index;
